import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialDashboardState, { ChartData, CriticalNotifications, Inventory } from './dashboard-initial-state';
import { AiReport } from '../models/dashboard.model';
import { MaintanceLog } from '@/src/pages/maintenance-logs/models/maintance-log.model';

const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState: initialDashboardState,
    reducers: {
        setAIReports(state, { payload }: PayloadAction<AiReport>) {
            state.aiReports = payload;
        },
        setInventory(state, { payload }: PayloadAction<Inventory>) {
            state.inventory = payload;
        },
        setEfficiency(state, { payload }: PayloadAction<any>) {
            state.efficiency = payload;
        },
        setAdvencedGraphFilter(state, { payload }: PayloadAction<boolean>) {
            state.advencedGraphFilter = payload;
        },
        setCriticalNotifications(state, { payload }: PayloadAction<CriticalNotifications[]>) {
            state.criticalNotifications = payload;
        },
        setAdvancedData(state, { payload }: PayloadAction<ChartData>) {
            state.advancedData = payload;
        },
        setNonEfficient(state, { payload }: PayloadAction<ChartData>) {
            state.nonEfficient = payload;
        },
        setMaintenanceLogs(state, { payload }: PayloadAction<MaintanceLog[]>) {
            state.maintenanceLogs = payload;
        }
    }
});

export const {
    setAIReports,
    setInventory,
    setEfficiency,
    setAdvencedGraphFilter,
    setCriticalNotifications,
    setAdvancedData,
    setNonEfficient,
    setMaintenanceLogs
} = dashboardSlice.actions

export default dashboardSlice.reducer